import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-597f5b96")

_pushScopeId("data-v-597f5b96")
const _hoisted_1 = { class: "flex" }
const _hoisted_2 = { class: "right-container flex-grow flex flex-col h-screen" }
const _hoisted_3 = { class: "flex-grow flex flex-col items-center bg-primary-100 overflow-y-scroll overflow-x-scroll px-12 pt-12" }
const _hoisted_4 = {
  key: 0,
  class: "w-full flex gap-4 panel-container rounded-md bg-white px-6 py-4 mb-16 lg:mb-8"
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" スクールAIのみ利用 ")
const _hoisted_6 = {
  key: 1,
  class: "w-full panel-container rounded-md bg-white px-6 py-4 mb-16 lg:mb-8"
}
const _hoisted_7 = /*#__PURE__*/_createVNode("h2", { class: "font-medium mb-4" }, "みんがくからのお知らせ", -1)
const _hoisted_8 = { class: "mr-4 text-gray-500" }
const _hoisted_9 = { class: "transition-all duration-300 hover:text-primary-500" }
const _hoisted_10 = {
  key: 0,
  class: "topic-icon bg-gray-400 mr-2"
}
const _hoisted_11 = {
  key: 1,
  class: "topic-icon bg-red-500 mr-2"
}
const _hoisted_12 = {
  key: 0,
  class: "text-gray-500"
}
const _hoisted_13 = {
  key: 2,
  class: "w-full panel-container rounded-md bg-white px-6 py-4 mb-16 lg:mb-8"
}
const _hoisted_14 = /*#__PURE__*/_createVNode("h2", { class: "font-medium mb-4" }, "スクールAIのお知らせ", -1)
const _hoisted_15 = { class: "mr-4 text-gray-500" }
const _hoisted_16 = { class: "transition-all duration-300 hover:text-primary-500" }
const _hoisted_17 = {
  key: 0,
  class: "topic-icon bg-gray-400 mr-2"
}
const _hoisted_18 = {
  key: 1,
  class: "topic-icon bg-red-500 mr-2"
}
const _hoisted_19 = {
  key: 0,
  class: "text-gray-500"
}
const _hoisted_20 = {
  key: 3,
  class: "w-full panel-container rounded-md bg-white px-6 py-4 mb-16 lg:mb-8"
}
const _hoisted_21 = { class: "font-medium mb-4" }
const _hoisted_22 = { class: "mr-4 text-gray-500" }
const _hoisted_23 = { class: "transition-all duration-300 hover:text-primary-500" }
const _hoisted_24 = {
  key: 0,
  class: "topic-icon bg-gray-400 mr-2"
}
const _hoisted_25 = {
  key: 1,
  class: "topic-icon bg-red-500 mr-2"
}
const _hoisted_26 = {
  key: 0,
  class: "text-gray-500"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_MNavBar = _resolveComponent("MNavBar")
  const _component_MHeaderPanel = _resolveComponent("MHeaderPanel")
  const _component_TutorPasswordBanner = _resolveComponent("TutorPasswordBanner")
  const _component_m_button = _resolveComponent("m-button")
  const _component_m_icon = _resolveComponent("m-icon")
  const _component_service_topic_add_modal = _resolveComponent("service-topic-add-modal")
  const _component_service_topic_edit_modal = _resolveComponent("service-topic-edit-modal")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_MNavBar),
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_MHeaderPanel, {
          title: "ホーム",
          breadcrumbs: []
        }),
        _createVNode("main", _hoisted_3, [
          _createVNode(_component_TutorPasswordBanner),
          (_ctx.isAdmin || _ctx.isAdminOfSchool)
            ? (_openBlock(), _createBlock("section", _hoisted_4, [
                _createVNode(_component_m_button, {
                  outline: "",
                  color: "secondary-500",
                  "hover-color": "secondary-600",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.addModalVisible = true))
                }, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(_ctx.isAdmin
                ? "新しいお知らせを登録"
                : "スクールに新しいお知らせを登録"), 1)
                  ]),
                  _: 1
                }),
                (_ctx.isAdmin)
                  ? (_openBlock(), _createBlock(_component_m_button, {
                      key: 0,
                      outline: "",
                      color: "secondary-500",
                      "hover-color": "secondary-600",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.addModalForSchoolAIVisible = true))
                    }, {
                      default: _withId(() => [
                        _hoisted_5
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (!_ctx.isExclusiveSchoolAiUser)
            ? (_openBlock(), _createBlock("section", _hoisted_6, [
                _hoisted_7,
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.serviceTopicsToDisplay, (topic, i) => {
                  return (_openBlock(), _createBlock("article", {
                    key: `topic${i}`,
                    class: "flex items-center my-1"
                  }, [
                    _createVNode("a", {
                      href: topic.url,
                      target: "_blank",
                      ref: "noopener noreferrer",
                      className: "flex items-center"
                    }, [
                      _createVNode("div", _hoisted_8, _toDisplayString(topic.date), 1),
                      _createVNode("div", _hoisted_9, [
                        (!topic.isPublished)
                          ? (_openBlock(), _createBlock("span", _hoisted_10, "未公開"))
                          : _createCommentVNode("", true),
                        (topic.isNew)
                          ? (_openBlock(), _createBlock("span", _hoisted_11, "new"))
                          : _createCommentVNode("", true),
                        _createTextVNode(_toDisplayString(topic.label), 1)
                      ])
                    ], 8, ["href"]),
                    (_ctx.isAdmin)
                      ? (_openBlock(), _createBlock("div", {
                          key: 0,
                          class: "ml-4 transition-all duration-300 cursor-pointer text-secondary-500 hover:text-secondary-600",
                          onClick: ($event: any) => (_ctx.startUpdatingServiceTopic(topic))
                        }, [
                          _createVNode(_component_m_icon, { type: "pencil" })
                        ], 8, ["onClick"]))
                      : _createCommentVNode("", true)
                  ]))
                }), 128)),
                (_ctx.serviceTopicsToDisplay.length === 0)
                  ? (_openBlock(), _createBlock("div", _hoisted_12, _toDisplayString(_ctx.isServiceTopicsLoaded
                ? "現在お知らせはありません。"
                : "読み込み中..."), 1))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.isAdmin || _ctx.isExclusiveSchoolAiUser)
            ? (_openBlock(), _createBlock("section", _hoisted_13, [
                _hoisted_14,
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.serviceTopicsToDisplayForSchoolAI, (topic, i) => {
                  return (_openBlock(), _createBlock("article", {
                    key: `topic${i}`,
                    class: "flex items-center my-1"
                  }, [
                    _createVNode("a", {
                      href: topic.url,
                      target: "_blank",
                      ref: "noopener noreferrer",
                      className: "flex items-center"
                    }, [
                      _createVNode("div", _hoisted_15, _toDisplayString(topic.date), 1),
                      _createVNode("div", _hoisted_16, [
                        (!topic.isPublished)
                          ? (_openBlock(), _createBlock("span", _hoisted_17, "未公開"))
                          : _createCommentVNode("", true),
                        (topic.isNew)
                          ? (_openBlock(), _createBlock("span", _hoisted_18, "new"))
                          : _createCommentVNode("", true),
                        _createTextVNode(_toDisplayString(topic.label), 1)
                      ])
                    ], 8, ["href"]),
                    (_ctx.isAdmin)
                      ? (_openBlock(), _createBlock("div", {
                          key: 0,
                          class: "ml-4 transition-all duration-300 cursor-pointer text-secondary-500 hover:text-secondary-600",
                          onClick: ($event: any) => (_ctx.startUpdatingServiceTopicForSchoolAi(topic))
                        }, [
                          _createVNode(_component_m_icon, { type: "pencil" })
                        ], 8, ["onClick"]))
                      : _createCommentVNode("", true)
                  ]))
                }), 128)),
                (_ctx.serviceTopicsToDisplayForSchoolAI.length === 0)
                  ? (_openBlock(), _createBlock("div", _hoisted_19, _toDisplayString(_ctx.isServiceTopicsLoaded
                ? "現在お知らせはありません。"
                : "読み込み中..."), 1))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.isAdminOfSchool)
            ? (_openBlock(), _createBlock("section", _hoisted_20, [
                _createVNode("h2", _hoisted_21, _toDisplayString(`${_ctx.schoolName}からのお知らせ`), 1),
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.serviceTopicsToDisplayOfSchool, (topic, i) => {
                  return (_openBlock(), _createBlock("article", {
                    key: `topic${i}`,
                    class: "flex items-center my-1"
                  }, [
                    _createVNode("a", {
                      href: topic.url,
                      target: "_blank",
                      ref: "noopener noreferrer",
                      className: "flex items-center"
                    }, [
                      _createVNode("div", _hoisted_22, _toDisplayString(topic.date), 1),
                      _createVNode("div", _hoisted_23, [
                        (!topic.isPublished)
                          ? (_openBlock(), _createBlock("span", _hoisted_24, "未公開"))
                          : _createCommentVNode("", true),
                        (topic.isNew)
                          ? (_openBlock(), _createBlock("span", _hoisted_25, "new"))
                          : _createCommentVNode("", true),
                        _createTextVNode(_toDisplayString(topic.label), 1)
                      ])
                    ], 8, ["href"]),
                    (topic.editable)
                      ? (_openBlock(), _createBlock("div", {
                          key: 0,
                          class: "ml-4 transition-all duration-300 cursor-pointer text-secondary-500 hover:text-secondary-600",
                          onClick: ($event: any) => (_ctx.startUpdatingServiceTopic(topic))
                        }, [
                          _createVNode(_component_m_icon, { type: "pencil" })
                        ], 8, ["onClick"]))
                      : _createCommentVNode("", true)
                  ]))
                }), 128)),
                (_ctx.serviceTopicsToDisplayOfSchool.length === 0)
                  ? (_openBlock(), _createBlock("div", _hoisted_26, _toDisplayString(_ctx.serviceTopicsOfSchoolFetched
                ? "現在お知らせはありません。"
                : "読み込み中..."), 1))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    (_ctx.addModalVisible)
      ? (_openBlock(), _createBlock(_component_service_topic_add_modal, {
          key: 0,
          onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.addModalVisible = false))
        }))
      : _createCommentVNode("", true),
    (_ctx.updateModalVisible)
      ? (_openBlock(), _createBlock(_component_service_topic_edit_modal, {
          key: 1,
          "service-topic": _ctx.selectedServiceTopic,
          onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.updateModalVisible = false))
        }, null, 8, ["service-topic"]))
      : _createCommentVNode("", true),
    (_ctx.addModalForSchoolAIVisible)
      ? (_openBlock(), _createBlock(_component_service_topic_add_modal, {
          key: 2,
          "to-school-a-i-user": "true",
          onClose: _cache[5] || (_cache[5] = ($event: any) => (_ctx.addModalForSchoolAIVisible = false))
        }))
      : _createCommentVNode("", true),
    (_ctx.updateModalForSchoolAIVisible)
      ? (_openBlock(), _createBlock(_component_service_topic_edit_modal, {
          key: 3,
          "service-topic": _ctx.selectedServiceTopicForSchoolAI,
          onClose: _cache[6] || (_cache[6] = ($event: any) => (_ctx.updateModalForSchoolAIVisible = false))
        }, null, 8, ["service-topic"]))
      : _createCommentVNode("", true)
  ], 64))
})